<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jB0Y17/tc-custom/9781455617944.jpg?1718079009300" alt="This image is the cover for the book History of the Rebel Yell"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History of the Rebel Yell
      </h1>
      <p class="bookDescription body article font2">
        <p>"Elliott's book is great!" -S. Waite Rawls III, president and CEO, Museum of the Confederacy, Richmond, Virginia</p><p>". . . a well-written book that should appeal to all history and Civil War buffs." -Frank Haight, Independence (MO) Examiner</p><p>The South's renowned Rebel Yell and its unique, demoralizing effects have been documented throughout history. Whether as a planned part of a battle strategy or as an instinctual expression of adrenaline, the yell motivated the rebel soldiers and unnerved the enemy. In this definitive work, the mighty hollers of these warriors as they met their foes in battle are detailed as are their origins and nature. This work sets out to recapture the yell, which has been largely lost to time, and bring it back to life at full volume.</p><p>The text suggests a substantial theory of the origins of the yell in Scotch-Irish history and analyzes its many variations and historical descriptions. Also assessed in these chapters are the few recorded versions of the Rebel Yell. This work includes historic stories and poems featuring the yell before concluding with a list of references.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terryl W. Elliott
      </h2>
      
      <p class="authorDescription body article">TERRYL W. ELLIOTT is a writer, historian, and poet whose work has appeared in various local and regional publications. He belongs to numerous Civil War, history, and writing organizations. Elliott lives in Independence, Missouri, with his wife and dog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18631636